import { render } from "./CardScreen.vue?vue&type=template&id=31aabeea&ts=true"
import script from "./CardScreen.vue?vue&type=script&lang=ts"
export * from "./CardScreen.vue?vue&type=script&lang=ts"

import "./CardScreen.vue?vue&type=style&index=0&id=31aabeea&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__